module.exports = __webpack_public_path__ + "static/media/BlueArrowUp.bf004acf.svg";